import Table from './Table';
import TableHead from './TableHead';
import TableRow from './TableRow';
import TableCell from './TableCell';
import TableSortLabel from './TableSortLabel';
import TableBody from './TableBody';

export {
  Table as default,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody
}


// WEBPACK FOOTER //
// ./src/components/common/Table/index.js